const GENRES = [
  { value: 'Horror', icon: 'ri-ghost-line' },
  { value: 'Psychological', icon: 'ri-mental-health-line' },
  { value: 'Supernatural', icon: 'ri-flashlight-line' },
  { value: 'Gothic', icon: 'ri-ancient-gate-line' },
  { value: 'Thriller', icon: 'ri-knife-line' },
  { value: 'Cosmic Horror', icon: 'ri-moon-foggy-line' },
  { value: 'Paranormal', icon: 'ri-eye-2-line' },
  { value: 'Dark Fantasy', icon: 'ri-sword-line' },
];

interface GenreSelectorProps {
  value: string;
  onChange: (v: string) => void;
  error?: string;
}

export default function GenreSelector({ value, onChange, error }: GenreSelectorProps) {
  return (
    <div>
      <label className="block text-sm font-semibold text-zinc-300 mb-3 tracking-wide uppercase" style={{ fontFamily: 'Cinzel, serif' }}>
        Genre <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {GENRES.map((g) => (
          <button
            key={g.value}
            type="button"
            onClick={() => onChange(g.value)}
            className={`flex items-center gap-2 px-4 py-3 rounded-lg border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
              value === g.value
                ? 'bg-red-900/40 border-red-600 text-red-400'
                : 'bg-zinc-900 border-zinc-700 text-zinc-400 hover:border-red-800 hover:text-zinc-200'
            }`}
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${g.icon} text-base`}></i>
            </div>
            {g.value}
          </button>
        ))}
      </div>
      {error && (
        <p className="text-red-400 text-xs flex items-center gap-1 mt-2">
          <i className="ri-error-warning-line"></i> {error}
        </p>
      )}
    </div>
  );
}
